// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Cta = require("../../../atom/Atom_Cta.bs.js");
var Atom_Row = require("../../../atom/Atom_Row.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Particle_Screen_Ds = require("../../../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../../../particle/Particle_Spacer_Ds.bs.js");

var rowGap = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");

var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, [CssJs.marginLeft({
            NAME: "px",
            VAL: 0
          })], undefined, [CssJs.marginLeft({
            NAME: "px",
            VAL: -15
          })]);

var rowBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeRight("S"));

function Organism_Concert_SocialLinks(Props) {
  var socialNetworks = Props.socialNetworks;
  var facebook = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(socialNetworks.facebook), null, (function (url) {
          return React.createElement(Atom_Cta.Link.make, {
                      href: url,
                      style: {
                        TAG: /* Header */10,
                        _0: {
                          TAG: /* Social */14,
                          _0: {
                            NAME: "Facebook",
                            VAL: "Header"
                          }
                        }
                      }
                    });
        }));
  var twitter = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(socialNetworks.twitter), null, (function (url) {
          return React.createElement(Atom_Cta.Link.make, {
                      href: url,
                      style: {
                        TAG: /* Header */10,
                        _0: {
                          TAG: /* Social */14,
                          _0: {
                            NAME: "Twitter",
                            VAL: "Header"
                          }
                        }
                      }
                    });
        }));
  var instagram = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(socialNetworks.instagram), null, (function (url) {
          return React.createElement(Atom_Cta.Link.make, {
                      href: url,
                      style: {
                        TAG: /* Header */10,
                        _0: {
                          TAG: /* Social */14,
                          _0: {
                            NAME: "Instagram",
                            VAL: "Header"
                          }
                        }
                      }
                    });
        }));
  var youtube = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(socialNetworks.youtube), null, (function (url) {
          return React.createElement(Atom_Cta.Link.make, {
                      href: url,
                      style: {
                        TAG: /* Header */10,
                        _0: {
                          TAG: /* Social */14,
                          _0: {
                            NAME: "Youtube",
                            VAL: "Header"
                          }
                        }
                      }
                    });
        }));
  var twitch = Belt_Option.mapWithDefault(Caml_option.nullable_to_opt(socialNetworks.twitch), null, (function (url) {
          return React.createElement(Atom_Cta.Link.make, {
                      href: url,
                      style: {
                        TAG: /* Header */10,
                        _0: {
                          TAG: /* Social */14,
                          _0: "Twitch"
                        }
                      }
                    });
        }));
  return React.createElement(Atom_Row.make, {
              blockSpace: rowBlockSpace,
              children: null,
              gap: rowGap,
              rules: rules
            }, facebook, twitter, instagram, youtube, twitch);
}

var make = Organism_Concert_SocialLinks;

exports.rowGap = rowGap;
exports.rules = rules;
exports.rowBlockSpace = rowBlockSpace;
exports.make = make;
/* rowGap Not a pure module */
